<template>
  <div id="evaluate" style="width:100%;height:100%">
    <el-row style="margin:30px 0">
      <el-col>
        <table border="1" bordercolor="#EBEEF5">
          <thead>
            <tr style="color:#909399">
              <th width="10%">序号</th>
              <th>评分条件</th>
              <th>得分情况(分)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>1</th>
              <td>相关业务报价分（根据具体业务报价方式待定）</td>
              <td>
                <el-input v-model.number="score.one" :readonly="isDisabled"></el-input>
              </td>
            </tr>
            <tr>
              <th>2</th>
              <td>自有蔬菜水果种植基地或者合作基地，提供土地流转合同或者基地合作协议得2分。</td>
              <td>
                <el-input v-model.number="score.two" :readonly="isDisabled"></el-input>
              </td>
            </tr>
            <tr>
              <th>3</th>
              <td>自有农残检测设备，提供图片以及购买发发票证明，并提供相关农残检测人员证书（需附网上证书查询截图），资料齐全得4分，否则不得分。</td>
              <td>
                <el-input v-model.number="score.three" :readonly="isDisabled"></el-input>
              </td>
            </tr>
            <tr>
              <th>4</th>
              <td>购买食品安全责任险，1000万—5000万得2分，5000万—1亿得5分。</td>
              <td>
                <el-input v-model.number="score.four" :readonly="isDisabled"></el-input>
              </td>
            </tr>
            <tr>
              <th>5</th>
              <td>具有食品类相关认证：1：ISO9001质量管理体系认证2：ISO14001环境管理体系认证3：ISO45001职业健康安全管理体系认证4：ISO22000食品安全管理体系认证。每个认证得2分，共8分。
              </td>
              <td>
                <el-input v-model.number="score.five" :readonly="isDisabled"></el-input>
              </td>
            </tr>
            <tr>
              <th>6</th>
              <td>运输能力：提供运输车辆情况，自有车辆或者租赁车辆并提供相关证明材料，租赁车辆需提供租赁合同，每辆车得2分，共5分。</td>
              <td>
                <el-input v-model.number="score.six" :readonly="isDisabled"></el-input>
              </td>
            </tr>
            <tr>
              <th>7</th>
              <td>农产品配送相关业绩证明，提供供应合同以及银行转账流水证明，每提供1份得1分，共10分。</td>
              <td>
                <el-input v-model.number="score.seven" :readonly="isDisabled"></el-input>
              </td>
            </tr>
            <tr>
              <th>8</th>
              <td>自有配送场地500㎡—1000㎡得2分，1001㎡—2000㎡得3分，2001㎡—3000㎡得5分，并提供现场图片，自有得提供房产证辅复印件，租赁的提供房产证复印件以及场地租赁合同。</td>
              <td>
                <el-input v-model.number="score.eight" :readonly="isDisabled"></el-input>
              </td>
            </tr>
            <tr>
              <th>9</th>
              <td>自建或者租赁冷藏库50平方，自建提供图片以及冷库安装合同，租赁提供租赁合同以及冷藏库所有权证明材料。该项资料齐全得2分，否则不得分。</td>
              <td>
                <el-input v-model.number="score.nine" :readonly="isDisabled"></el-input>
              </td>
            </tr>
            <tr>
              <th>10</th>
              <td>人员配置情况，驾驶员要求4名，提供驾驶证和健康证复印件，每1人得0.5分。配送员要求4名，提供健康证，每人得0.5分。</td>
              <td>
                <el-input v-model.number="score.ten" :readonly="isDisabled"></el-input>
              </td>
            </tr>
            <tr style="height:42px">
              <th>总计</th>
              <td></td>
              <td style="text-align:center">
                {{ Sum }}
              </td>
            </tr>
          </tbody>
        </table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button size="medium" @click="submitScore" style="float:right;margin-top:20px" :disabled="isDisabled">提交</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      score: {
        one: '',
        two: '',
        three: '',
        four: '',
        five: '',
        six: '',
        seven: '',
        eight: '',
        nine: '',
        ten: '',
      },
      HAD_EVALUATION: '',
      isDisabled: false,
    };
  },
  methods: {
    queryScore() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10011',
            OTYPE: 6,
            SUPPLIER_ID: Number(sessionStorage.getItem('SUPPLIER_ID_Evaluate')),
            MONTH: sessionStorage.getItem('MONTH_Evaluate'),
            GYS_ID: sessionStorage.getItem('GYS_ID_Evaluate'),
          };
          http.post(params).then((result) => {
            if (result[0].DATA.length != 0) {
              this.score = result[0].DATA;
            }
            this.HAD_EVALUATION = result[0].HAD_EVALUATION;
            this.isisDisabled();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    submitScore() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10011',
            OTYPE: 7,
            SUPPLIER_ID: Number(sessionStorage.getItem('SUPPLIER_ID_Evaluate')),
            MONTH: sessionStorage.getItem('MONTH_Evaluate'),
            GYS_ID: sessionStorage.getItem('GYS_ID_Evaluate'),
            EVALUATION: this.score,
          };
          document.body.style.cursor = 'default';
          http.post(params).then((result) => {
            this.$message.show({ text: '提交成功', type: 'success' });
            this.queryScore();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    isisDisabled() {
      if (this.HAD_EVALUATION == 1) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
  },
  computed: {
    Sum() {
      return Number(this.score.one) + Number(this.score.two) + Number(this.score.three) + Number(this.score.four) + Number(this.score.five) + Number(this.score.six) + Number(this.score.seven) + Number(this.score.eight) + Number(this.score.nine) + Number(this.score.ten);
    },
  },
  created() {
    this.queryScore();
  },
  destroyed() {
    sessionStorage.removeItem('MONTH_Evaluate');
    sessionStorage.removeItem('SUPPLIER_ID_Evaluate');
    sessionStorage.removeItem('GYS_ID_Evaluate');
  },
};
</script>
<style scoped>
table {
  border-collapse: collapse;
  color: #606266;
}

table td {
  color: #606266;
}

.el-input>>>.el-input__inner {
  border: 0 !important;
  padding: 0 !important;
  text-align: center;
}

table tbody tr :nth-child(2) {
  padding: 0 0 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/financeCenter/GYS_Evaluate.vue